<div class="col-md-12 mb-30" [hidden]="Selected_Offtime_Record.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">اطلاعات مرخصی ساعتی</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">بازه زمانی</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">اعمال شود</option>
            <option value="0">اعمال نشود</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ شروع</label>
          <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">تاریخ پایان</label>
          <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> وضیعت </label>
          <select [(ngModel)]="Filter_Status" name="Filter_Status" class="custom-select">
            <option value="0">همه موارد</option>
            <option value="1">در حال بررسی</option>
            <option value="2">عدم تایید شده</option>
            <option value="3">تایید شده</option>

          </select>
        </div>
      </div>
      <div class="row">

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> پرسنل </label>
          <app-PersonOption (OnBack_Person_Action)="OnGet_Person_Action($event)">
          </app-PersonOption>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Offtime(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-left: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <button *ngIf="!Procssing" routerLink="/OffTimeForm" type="button" class="btn btn-success"
            style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه درخواست</th>
              <th>نام و نام خانوادگی</th>
              <th>ساعت شروع</th>
              <th>ساعت پایان</th>
              <th>روز کاری</th>

              <th>وضیعت</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_Offtime
                  | paginate
                          : {
                              id: 'DataList_FeildTable',
                              itemsPerPage: 50,
                              currentPage: page,
                              totalItems: DataList_Offtime.length
                            }">

              <tr>
                <td rowspan="2">{{DataList_Offtime.indexOf(item)+1}}</td>
                <td>{{item.id}}</td>
                <td>{{item.fullname}}</td>
                <td>{{item.startTime}}</td>
                <td>{{item.endTime}}</td>
                <td>{{item.requestDate}}</td>

                <td>
                  <p *ngIf="item.status==1" style="color: rgb(20, 77, 220);">در حال بررسی</p>
                  <p *ngIf="item.status==2" style="color: #489b39;">تایید</p>
                  <p *ngIf="item.status==3" style="color: crimson;">عدم تایید</p>
                </td>

                <td rowspan="2">
                  <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a href="{{BaseUrl1}}{{item.flowchart.flochart_id}}{{BaseUrlCo}}{{item.flowchart.makerId}}"
                          target="_blank" class="dropdown-item"><i class="fa fa-wpbeginner"></i>
                          گردش کار
                        </a>
                        <a style="cursor: pointer;" (click)="ReadData_History(item)" class="dropdown-item"><i
                            class="fa fa-history"></i>
                          تاریخچه گردش کار
                        </a>

                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <th>شرح</th>
                <td colspan="5">{{item.dsc}}</td>
              </tr>

            </ng-container>

          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="بعدی" previousLabel="قبلی" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>




<div *ngIf="Selected_Offtime_Record.id>0" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">تاریخچه گردش درخواست '{{Selected_Offtime_Record.flowchart.uniCode}}'
          </h5>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-FlowchartHistory [DataList_History]="DataList_History"></app-FlowchartHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button"
            (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>حدف آخرین
            ارجاع</button>
        </div>


      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-left: 5px;"> بازگشت
    </button>
  </div>

</div>








<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>شناسه درخواست</th>
      <th>نام و نام خانوادگی</th>
      <th>ساعت شروع</th>
      <th>ساعت پایان</th>
      <th>روز کاری</th>

      <th>وضیعت</th>

      <th>شرح</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Offtime">
      <td>{{DataList_Offtime.indexOf(item)+1}}</td>
      <td>{{item.id}}</td>
      <td>{{item.fullname}}</td>
      <td>{{item.startTime}}</td>
      <td>{{item.endTime}}</td>
      <td>{{item.requestDate}}</td>

      <td>
        <p *ngIf="item.status==1" style="color: rgb(20, 77, 220);">در حال بررسی</p>
        <p *ngIf="item.status==2" style="color: #489b39;">تایید</p>
        <p *ngIf="item.status==3" style="color: crimson;">عدم تایید</p>
      </td>
      <td>{{item.dsc}}</td>

    </tr>
  </tbody>
</table>